import React, { useEffect } from "react";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Dialog } from "../../../components";
import { connect, useSelector } from "react-redux";
import { getAllData } from "../../../redux/actions/free/homeActions";

// get step data from redux main state
const data = (state) => state.home;

function AssesstmentReview(props) {
  const [open, setOpen] = React.useState(false);
  let savedData = useSelector(data);

  let { handleModal ,handleModalClose} = props;

  let handleConfirmModal = () => {
    setOpen(true);
  };

  let handleDialogConfirm = () => {
    setOpen(false);
    handleModal(false, true)
  };

  let step1Data = savedData && savedData.step1Data
  let step2Data = savedData && savedData.step2Data
  let step3Data = savedData && savedData.step3Data
  let step4Data = savedData && savedData.step4Data



  let AllData = () => {
    props.getAllData(4);
  };
  useEffect(() => {
    AllData();
  }, [open]);
  return (
    <div>
    {open ? (
      <Dialog
        open={open}
        onDisAgree={() => setOpen(false)}
        onAgree={handleDialogConfirm}
        title="Are you sure you want to save the settings? "
        description="Once confirmed, you won't be able to make any changes."
      />
    ) : null}
    <div className="bg-[#FFD700] py-4 px-6 flex justify-between items-center">
      <h1></h1>
      <h1 className="text-center text-[#007E8C] font-bold text-2xl">
        Review Your Assessment
      </h1>

      <div className="flex justify-center items-center bg-[#3B4345] rounded-sm">
        <CloseIcon
          className="cursor-pointer  text-white"
          onClick={() => {
            handleModalClose(false);
          }}
        />
      </div>
    </div>
    <div className="py-6 2xl:px-20 xl:px-20 lg:px-20 px-10">
      <div className="flex flex-row flex-wrap 2xl:justify-between xl:justify-between lg:justify-between justify-center">
        <div className="bg-white ">
          {/* Get Started Step Start  */}
          <div>
            <h3 className="text-[#007E8C] underline font-bold text-lg ">
              1. Get Started
            </h3>
            <div className="my-2">
              <div>
                <h3 className="text-[#007E8C] font-medium text-base mt-1 ml-4 ">
                  Assessment Name
                </h3>
                <p className="text-[#3B4345] font-normal ml-6 mt-1">
                  - {step1Data && step1Data.assessmentName}
                </p>
              </div>
              <div>
                <h3 className="text-[#007E8C] font-medium text-base mt-1 ml-4 ">
                  Job Type
                </h3>
                <div className="text-[#3B4345] font-normal ml-6 mt-1">
                  {step1Data &&
                    step1Data.jobType &&
                    step1Data.jobType
                      .split(", ")
                      .map((item, index) => <p key={index}>- {item}</p>)}
                </div>
              </div>
            </div>
          </div>
          {/* Get Started Step End */}
          <div className="mt-6">
            {/* Chosen Assessments Step Start  */}
            <div>
              <h3 className="text-[#007E8C] underline font-bold text-lg ">
                2. Chosen Assessments
              </h3>

              <div className="my-2">
                {step2Data &&
                step2Data.competenciesBucket &&
                step2Data.competenciesBucket.length > 0 ? (
                  <h3 className="text-[#007E8C] font-medium text-base ">
                    Competency Assessments
                  </h3>
                ) : null}

                <div>
                  {step2Data && step2Data.competenciesBucket
                    ? step2Data.competenciesBucket.map((item, i) => {
                        return (
                          <p
                            key={i}
                            className="text-[#3B4345] font-normal ml-6 mt-1"
                          >
                            - {item}
                          </p>
                        );
                      })
                    : null}
                </div>

                <div className="my-2">
                  {step2Data &&
                  step2Data.cognitiveBucket &&
                  step2Data.cognitiveBucket.length > 0 ? (
                    <h3 className="text-[#007E8C] font-medium text-base ">
                      Cognitive Ability Assessments
                    </h3>
                  ) : null}

                  <div>
                    {step2Data && step2Data.cognitiveBucket
                      ? step2Data.cognitiveBucket.map((item, index) => {
                          return (
                            <p
                              key={index}
                              className="text-[#3B4345] font-normal ml-4 mt-1"
                            >
                              - {item}
                            </p>
                          );
                        })
                      : null}
                  </div>
                </div>
                <div className="my-2">
                  {step2Data &&
                  step2Data.aptitudeBucket &&
                  step2Data.aptitudeBucket.length > 0 ? (
                    <h3 className="text-[#007E8C] font-medium text-base ">
                      Aptitude Assessments
                    </h3>
                  ) : null}

                  <div>
                    {step2Data && step2Data.aptitudeBucket
                      ? step2Data.aptitudeBucket.map((item, index) => {
                          return (
                            <p
                              key={index}
                              className="text-[#3B4345] font-normal ml-4 mt-1"
                            >
                              - {item}
                            </p>
                          );
                        })
                      : null}
                  </div>
                </div>
              </div>
            </div>
            {/*  Chosen Assessments Step End  */}
          </div>
        </div>

        <div className="bg-white ">
          <div>
            {/*  Customize Step Start  */}
            <div>
              <h3 className="text-[#007E8C] underline font-bold text-lg ">
                3. Customize
              </h3>
              <div className="my-2">
                <h3 className="text-[#007E8C] font-medium text-base ">
                  Registration Fields
                </h3>
                <div>
                  {step3Data &&
                  step3Data.personalInFeilds &&
                  step3Data.personalInFeilds.length > 0 ? (
                    <h3 className="text-[#007E8C] font-normal text-base italic  mt-1 ml-4 ">
                      Candidate Personal Information
                    </h3>
                  ) : null}

                  {step3Data && step3Data.personalInFeilds
                    ? step3Data.personalInFeilds.map((item, i) => {
                        return (
                          <p
                            key={i}
                            className="text-[#3B4345] font-normal ml-6 mt-1"
                          >
                            - {item}
                          </p>
                        );
                      })
                    : null}
                </div>
                <div>
                  {step3Data &&
                  step3Data.academicFeilds &&
                  step3Data.academicFeilds.length > 0 ? (
                    <h3 className="text-[#007E8C] font-normal text-base italic  mt-1 ml-4 ">
                      Academic Qualification
                    </h3>
                  ) : null}

                  {step3Data && step3Data.academicFeilds
                    ? step3Data.academicFeilds.map((item, i) => {
                        return (
                          <p
                            key={i}
                            className="text-[#3B4345] font-normal ml-6 mt-1"
                          >
                            - {item}
                          </p>
                        );
                      })
                    : null}
                </div>
                <div>
                  {step3Data &&
                  step3Data.employmentFeilds &&
                  step3Data.employmentFeilds.length > 0 ? (
                    <h3 className="text-[#007E8C] font-normal text-base italic  mt-1 ml-4 ">
                      Employment History
                    </h3>
                  ) : null}
                  {step3Data && step3Data.employmentFeilds
                    ? step3Data.employmentFeilds.map((item, i) => {
                        return (
                          <p
                            key={i}
                            className="text-[#3B4345] font-normal ml-6 mt-1"
                          >
                            - {item}
                          </p>
                        );
                      })
                    : null}
                </div>
                <div className="my-2">
                  <h3 className="text-[#007E8C] font-medium text-base ">
                    Log In Method
                  </h3>
                  <div>
                    <p className="text-[#3B4345] font-normal ml-4 mt-1">
                      {step3Data && step3Data.loginMethod === "emailLogin"
                        ? "Email Address"
                        : step3Data && step3Data.loginMethod === "linkedLogin"
                        ? "LinkedIn"
                        : null}
                    </p>
                  </div>
                </div>
                {/* <div className="my-2">
                {(step3 && step3.landingLoginD) ||
                (step3 && step3.landingLoginM) ||
                (step3 && step3.endscreenD) ||
                (step3 && step3.endscreenM) ? (
                  <h3 className="text-[#007E8C] font-medium text-base ">
                    Custom Artwork
                  </h3>
                ) : null}

                <div>
                  <p className="text-[#3B4345] font-normal ml-4 mt-1">
                    {step3 &&
                      step3.landingLoginD &&
                      step3.landingLoginD.name &&
                      step3.landingLoginD.name}
                  </p>
                  <p className="text-[#3B4345] font-normal ml-4 mt-1">
                    {step3 &&
                      step3.landingLoginM &&
                      step3.landingLoginM.name &&
                      step3.landingLoginM.name}
                  </p>
                  <p className="text-[#3B4345] font-normal ml-4 mt-1">
                    {step3 &&
                      step3.endscreenD &&
                      step3.endscreenD.name &&
                      step3.endscreenD.name}
                  </p>
                  <p className="text-[#3B4345] font-normal ml-4 mt-1">
                    {step3 &&
                      step3.endscreenM &&
                      step3.endscreenM.name &&
                      step3.endscreenM.name}
                  </p>
                  <p className="text-[#3B4345] font-normal ml-4 mt-1">
                    {step3 &&
                      step3.favicon &&
                      step3.favicon.name &&
                      step3.favicon.name.substring(0, 14) + step3.favicon &&
                      step3.favicon.type &&
                      step3.favicon.type
                    }
                  </p>
                </div>
              </div> */}
              </div>
            </div>
            {/*  Customize Step End  */}
          </div>

          {/* Configure & Launch Step Start  */}
          <div className="mt-4">
            <h3 className="text-[#007E8C] underline font-bold text-lg ">
              4. Configure & Launch
            </h3>
            <div className="my-2">
              {step4Data && step4Data.showCandidateSurvey ? (
                <h3 className="text-[#007E8C] font-medium text-base ">
                  Candidate Experience
                </h3>
              ) : null}
              <div>
                {step4Data && step4Data.showCandidateSurvey ? (
                  <p className="text-[#3B4345] font-normal ml-4 mt-1">
                    - Candidate Experience Survey
                  </p>
                ) : null}
                {step4Data && step4Data.showCandidateVideo ? (
                  <p className="text-[#3B4345] font-normal ml-4 mt-1">
                    - Candidate Tutorial Video
                  </p>
                ) : null}
              </div>
            </div>
            <div className="my-2">
              {(step4Data && step4Data.facialRecognition) ||
              (step4Data && step4Data.gameAutoLock) ? (
                <h3 className="text-[#007E8C] font-medium text-base ">
                  Anti Cheat Feature
                </h3>
              ) : null}

              <div>
                {step4Data && step4Data.facialRecognition ? (
                  <p className="text-[#3B4345] font-normal ml-4 mt-1">
                    - Facial Recognition
                  </p>
                ) : null}
                {step4Data && step4Data.gameAutoLock ? (
                  <p className="text-[#3B4345] font-normal ml-4 mt-1">
                    - Game Auto Lock
                  </p>
                ) : null}
              </div>
            </div>
            <div className="my-2">
              <h3 className="text-[#007E8C]  font-medium text-base ">
                Launch Date & Closing Date
              </h3>
              <div>
                <p className="text-[#3B4345] font-normal ml-4 mt-1">
                  -{" "}
                  {step4Data &&
                    moment
                      .utc(step4Data.launchDate)
                      .local()
                      .format("YYYY-MM-DD")}{" "}
                  to{" "}
                  {step4Data &&
                    moment
                      .utc(step4Data.closingDate)
                      .local()
                      .format("YYYY-MM-DD")}
                </p>
              </div>
            </div>
          </div>
          {/* Get Started Step End */}
        </div>
      </div>
      <div className="flex justify-between flex-row my-6">
        <Button
          onClick={() => {
            handleModalClose(false);
          }}
          name={"Back"}
          customStyle={
            "bg-[#FEBB12] hover:bg-[#FEBB12] text-[white] font-bold mt-[1rem] w-48"
          }
        />
        <Button
          onClick={handleConfirmModal}
          name={"Confirm"}
          customStyle={
            "bg-[#FEBB12] hover:bg-[#FEBB12] text-[white] font-bold mt-[1rem] w-48"
          }
        />
      </div>
    </div>
  </div>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  getAllData,
})(AssesstmentReview);
